import { Response } from 'src/types';

import { apiRequest } from '../api';
import { endpoints } from '../config';
import { RequestMethodEnum } from '../types';
import { createFormData } from 'src/helpers/formData';
import { AddBrandingRequest, Branding, EditBrandingRequest } from './types';

export const addBranding = async (data: AddBrandingRequest) => {
  const formData = createFormData(data);

  const response = await apiRequest<Response<Branding>, AddBrandingRequest>(
    endpoints.branding.add,
    RequestMethodEnum.POST,
    {
      formData,
      showErrorMessage: true,
      showSuccessMessage: true,
    }
  );
  return response?.data;
};

export const getBranding = async (
  id: number
): Promise<Branding | undefined> => {
  const response = await apiRequest<Response<Branding>>(
    endpoints.branding.getDetails(id),
    RequestMethodEnum.GET,
    {}
  );
  return response?.data;
};

export const getMyBrands = async (): Promise<Branding[]> => {
  const response = await apiRequest<Response<Branding[]>>(
    endpoints.branding.getAll,
    RequestMethodEnum.GET,
    {}
  );
  return response?.data || [];
};

export const editBranding = async (id: number, data: EditBrandingRequest) => {
  const formData = createFormData(data);

  const response = await apiRequest<Response<Branding>, FormData>(
    endpoints.branding.update(id),
    RequestMethodEnum.PATCH,
    {
      formData,
      showErrorMessage: true,
      showSuccessMessage: true,
    }
  );
  return response?.data;
};

export const deleteBranding = async (
  id: number
): Promise<{ id: number } | undefined> => {
  const response = await apiRequest<Response<{ id: number }>, void>(
    endpoints.branding.delete(id),
    RequestMethodEnum.DELETE,
    {
      showErrorMessage: true,
      showSuccessMessage: true,
    }
  );
  return response?.data;
};
